import { Skeleton } from '@progress/kendo-react-indicators'
import React from 'react'

const ActionbarSkelton = ({ length = 3 }) => {
    return (
        <div className="d-flex justify-content-between align-items-center py-3">
            <div className="d-flex gap-2 align-items-end">
                {Array.from({ length }).map((item, index) => (
                    <div key={index} className="d-flex flex-column gap-1">
                        <Skeleton
                            shape="text"
                            className="rounded"
                            style={{
                                width: "50px",
                                height: "20px",
                            }}
                        />
                        <Skeleton
                            shape="rectangle"
                            className="rounded"
                            style={{
                                width: "150px",
                                height: "38px",
                            }}
                        />
                    </div>
                ))}

            </div>
            <div className="d-flex gap-1 align-items-end h-100 ms-2">
                <Skeleton
                    shape="rectangle"
                    className="rounded"
                    style={{
                        width: "200px",
                        height: "40px",
                    }}
                />
                <Skeleton
                    shape="rectangle"
                    className="rounded"
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                />
                <Skeleton
                    shape="rectangle"
                    className="rounded"
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                />
            </div>
        </div>
    )
}

export default ActionbarSkelton